<template>
<div class="contentGlobal">
    <div class="content inner">
        <div class="login boxLogin">
            <b-row>
                <b-col>
                    <h4>User profile</h4>
                    <form @submit.prevent="profile">
                        <b-row :class="{ 'form-group--error': $v.form2.username.$error }">
                            <b-col cols="2" class="right"><label class="w100 right">Name</label></b-col>
                            <b-col cols="10">
                                <!-- <b-form-input type="text" placeholder="name" v-model.trim="$v.form2.username.$model"></b-form-input> -->
                                <input class="form-control" v-model.trim="$v.form2.username.$model"/>
                            </b-col>  
                        </b-row>
                        <b-row v-if="$v.form2.$error">
                            <div class="error" v-if="!$v.form2.username.required">{{ $t('messages.login.error.required') }}</div>
                            <div class="error" v-if="!$v.form2.username.minLength">{{ $t('messages.login.error.minLength', { field: $t("messages.login.name"), value: $v.form2.username.$params.minLength.min }) }} </div>
                        </b-row >

                        <b-row class="mtop10">
                            <b-col cols="2" class="right"><label class="w100 right">Phone</label></b-col>
                            <b-col cols="10">
                            <b-form-input type="text" placeholder="phone" v-model.trim="userProfile.phone"></b-form-input></b-col>
                        </b-row>
  
                        <b-row class="mtop10">
                            <b-col cols="2" class="right"><label class="w100 right">Prefered language</label></b-col>
                            <b-col cols="10">
                                <select class="form-control" :required="true" v-model="userProfile.language">
                                    <option 
                                        v-for="option in languages" :key="option.code" 
                                        v-bind:value="option.code"
                                        :selected="option.code == userProfile.language"
                                        >{{ option.name }}
                                    </option>
                                </select>
                            </b-col>
                        </b-row>
        
                        <button type="submit" class="button">Update Profile</button>
                    </form>
                    <h4>Change password</h4>
                    <form @submit.prevent="submit">
                        <b-row class="form-group" :class="{ 'form-group--error': $v.form.password.$error }">
                            <b-col cols="2" class="right"><label class="form__label">{{ $t("messages.login.password") }}</label></b-col>
                            <b-col cols="10"><input class="form-control" type="password" v-model.trim="$v.form.password.$model"/></b-col>
                        </b-row>
                        <b-row  v-if="$v.form.$error">
                            <div class="error" v-if="!$v.form.password.required">{{ $t('messages.login.error.required') }}</div>
                            <div class="error" v-if="!$v.form.password.minLength">{{ $t('messages.login.error.minLength', { field: $t("messages.login.password"), value: $v.form.password.$params.minLength.min }) }} </div>
                        </b-row>
            
                        <b-row class="form-group" :class="{ 'form-group--error': $v.form.repeatPassword.$error }">
                            <b-col cols="2" class="right"><label class="form__label">{{ $t("messages.login.repeatPassword") }}</label></b-col>
                            <b-col cols="10" class="right"><input class="form-control" type="password" v-model.trim="$v.form.repeatPassword.$model" data-vv-validate-on="blur" /></b-col>
                        </b-row>
                        <b-row v-if="$v.form.$error">
                            <div class="error" v-if="!$v.form.repeatPassword.sameAsPassword"> {{ $t('messages.login.error.passwordIdentical') }}</div>
                        </b-row>
                        <button type="submit" class="button">
                            Update password
                        </button>
                    </form>
                </b-col>
            </b-row>
        </div>
    </div>
    <modal name="login-box"
        transition="nice-modal-fade"
        :min-width="200"
        :min-height="250"
        :pivot-y="0.5"
        :adaptive="true"
        :scrollable="true"
        :reset="true"
        width="30%"
        height="auto"
        :clickToClose="false">
        <div class="modal-detail-content">
            <b-row>
                <b-btn @click="$modal.hide('login-box');" class="closePopup"> <icon name="times-circle"></icon> </b-btn>
            </b-row>
            <b-col>
                <login-box v-on:onLogin="onLogin"></login-box>
            </b-col>
        </div>
    </modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import FileSelect from './utils/FileSelect.vue'
import LoginBox from './utils/LoginBox.vue'
import {required,email, sameAs,  minLength} from 'vuelidate/lib/validators';
const {fb,auth} = require('../firebaseConfig.js')

export default {
    components: {
        FileSelect,
        LoginBox
    },
    data() {
        return {
            email:'',
            lang: '',
            file: null,
            selectedFile: null,
            form: {
                password: "",
                repeatPassword:"",
            },
            form2: {
                username:'',
            },
        }
    },
    validations: {
        form2: {
            username: {
                required,
                minLength: minLength(4)
            }
        },
        form: {
            password: {
                required,
                minLength: minLength(6)
            },
            repeatPassword: {
                sameAsPassword: sameAs('password')
            }
        }
    },
    computed: {
        ...mapState(['userProfile', 'languages', 'currentUser']),
    },
    created(){
        this.$nextTick(() => {
            this.setName()
        });
    },
    methods: {
        setName() {
            this.form2.username = this.userProfile.name
        },
        profile(){
            this.$v.form2.$touch();
            if (this.$v.form2.$error){
                return
            }
            this.userProfile.name = this.form2.username 
            this.updateProfile();
        },
        submit() {
            this.$v.form.$touch();
            if (this.$v.form.$error){
                return
            }
           this.updateProfilePassword();
        },
        onSelectedFile(event) {
            this.selectedFile = event;
        },
        onCancelFile(event) {
            this.selectedFile = event;
        },
        onLogin(login){
            var credential = fb.auth.EmailAuthProvider.credential(
                this.currentUser.email,
                login.password
            );
            this.currentUser.reauthenticateAndRetrieveDataWithCredential(credential).then( () => {
               console.log('Re-authenticated user');
                this.$modal.hide('login-box');
                this.updateProfilePassword();
            }).catch(function(error) {
                console.log(error);
            });
        },
        updateProfilePassword() {
            this.$snotify.async('Updating password', 'Sending data', () => new Promise((resolve, reject) => {
                this.currentUser.updatePassword(this.form.password).then( ()=> {
                    this.$v.form.$reset();
                    this.form.password = '';
                    this.form.repeatPassword = '';
                    resolve({
                        title: 'Password updated!',
                        config: {
                            timeout: 1000,
                            closeOnClick: true
                        }
                    })
                }, error => {
                    this.$modal.show('login-box');
                    reject()
                });
            }))  
        },
        updateProfile() {
            this.$snotify.async('Updating user profile', 'Sending data', () => new Promise((resolve, reject) => {
                this.$store.dispatch('updateProfile',
                  this.userProfile
                ).then(response => {
                    this.$store.dispatch('changeStyle', this.userProfile.uiBackground)
                   resolve({
                        title: 'User updated!',
                        config: {
                            timeout: 1000,
                            closeOnClick: true
                        }
                    })
                }, error => {
                    reject({
                        title: 'Error updating user',
                        body: error,
                        config: {
                            timeout: 3000,
                            closeOnClick: true
                        }
                    })
                });
            }))
        }
    }
}
</script>

<style scoped>
.boxLogin .col {
    min-height: 262px;
}

.userImage {
    display: inline-block;
    width: 150px;
    height: 150px;
    border-radius: 50%;

    object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue